class MainNav {
  constructor() {
    this.el = document.querySelector('.js-main-nav');
    this.header = document.querySelector('.js-header');
    this.triggers = [...document.querySelectorAll('.main-nav__link')];
    this.navTrigger = document.querySelector('.js-nav-toggle');

    if (this.el && this.header && this.triggers && this.navTrigger) {
      this.init();
    }
  }

  handleMouseEnter = () => {
    this.el.classList.add('isOpen');
  };

  handleMouseLeave = () => {
    this.el.classList.remove('isOpen');
  };

  handleClick = e => {
    e.preventDefault();
    if (this.header.classList.contains('hasOpenNav')) {
      document.documentElement.classList.remove('isFixed');
      this.header.classList.remove('hasOpenNav');
    } else {
      document.documentElement.classList.add('isFixed');
      this.header.classList.add('hasOpenNav');
    }
  };

  init() {
    this.navTrigger.addEventListener('click', this.handleClick);

    this.triggers.forEach(trigger =>
      trigger.addEventListener('mouseenter', this.handleMouseEnter),
    );

    this.header.addEventListener('mouseleave', this.handleMouseLeave);
  }
}

export default MainNav;
